module.exports = __webpack_public_path__ + "static/media/keyArt.bcd1278e.webp";